// Spinner.js
import React from 'react';

const Spinner = () => {
    return (
        <div className="loading-container" style={{ textAlign: 'center', marginTop: '150px' }}>
            {/* <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="sr-only">Loading...</span>
            </div>
            <h4 style={{ marginTop: '20px' }}>Loading, please wait...</h4> */}
        </div>
    );
};

export default Spinner;
